import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import Logout from '@hellodarwin/icons/dist/icons/Logout';
import { useCallback, useMemo } from 'react';
import { useLogin } from '../providers/login-provider';
const useLogoutLink = ({ Icon = Logout, } = {}) => {
    const { handleLogout } = useLogin();
    const { t } = useTranslations();
    const onClick = useCallback(() => {
        handleLogout();
    }, [handleLogout]);
    const logoutLink = useMemo(() => ({
        pathname: '/logout',
        onClick,
        label: t('navigation|logout'),
        Icon,
        withBorderTop: true,
    }), [onClick, t, Icon]);
    return logoutLink;
};
export default useLogoutLink;
